import { Center, Loader } from "@mantine/core";

/**
 * Full-viewport centered loader. Used as the Suspense fallback for lazily
 * loaded portal layouts and pages (US-044 AC11), and matches the loader the
 * route guards already render so code-split navigations look consistent.
 */
export function FullPageLoader() {
  return (
    <Center h="100vh">
      <Loader size="xl" />
    </Center>
  );
}
